// extracted by mini-css-extract-plugin
module.exports = {"menu":"menu-module--menu--2h07D"};